import { FaWhatsapp } from "react-icons/fa";
import { FiBell, FiMessageCircle, FiTrendingUp, FiCompass, FiHeart, FiLock } from "react-icons/fi";
import Reveal from "../../components/landing/Reveal";
import useInView from "../../components/landing/useInView";
import { WHATSAPP_COMMUNITY_URL } from "../../constants/community";
import oneriIcon from "../../assets/icons/terakki-grup-oneri-128.png";
import hataIcon from "../../assets/icons/terakki-grup-hata-128.png";
import gelistirmeIcon from "../../assets/icons/terakki-grup-gelistirme-128.png";

const external = { target: "_blank", rel: "noopener noreferrer" };

// Masaüstü sahnesi: ortada Katıl düğmesi, iç halkada üç grup, dış halkada
// faydalar ve adap. Açılar derece, 0 sağ, 90 alt (ekran yönü).
const STAGE = { w: 1100, h: 860, cx: 550, cy: 430 };
const INNER = 240;
const OUTER = 380;

const at = (angle, radius) => {
  const rad = (angle * Math.PI) / 180;
  return { x: STAGE.cx + radius * Math.cos(rad), y: STAGE.cy + radius * Math.sin(rad) };
};

// WhatsApp topluluğundaki üç grup; ikonlar gruplarda kullanılanlarla aynı.
const GROUPS = [
  {
    icon: hataIcon,
    title: "Hata Bildirimi",
    purpose: "Uygulamada bir şey beklediğiniz gibi çalışmıyorsa buraya yazın; en kısa sürede bakıp düzeltelim.",
    angle: 210,
  },
  {
    icon: oneriIcon,
    title: "İstek ve Öneri",
    purpose: "Görmek istediklerinizi ve iyileştirme fikirlerinizi paylaşın; en çok istenenler önce gelir.",
    angle: 330,
  },
  {
    icon: gelistirmeIcon,
    title: "Geliştirme",
    purpose: "Yeni özellikleri yayından önce deneyin, yakında gelecekler hakkında görüş bildirin.",
    angle: 90,
  },
];

// Faydalar üst yayda; duyurular topluluğun duyuru kanalından kendiliğinden gelir.
const BENEFITS = [
  { Icon: FiBell, title: "Duyuruları ilk siz duyun", sub: "Duyuru kanalından kendiliğinden gelir", angle: 240 },
  { Icon: FiMessageCircle, title: "Soru sorun, cevap alın", sub: "Ekibimiz ve kullanıcılar yardımcı olur", angle: 300 },
  { Icon: FiTrendingUp, title: "Terakki'yi birlikte geliştirelim", sub: "Önerileriniz yol gösterir", angle: 0 },
];

// Topluluk adabı alt yayda.
const RULES = [
  { Icon: FiCompass, title: "Konuya uygun gruba yazın", sub: "İlgili grupta daha hızlı cevaplanır", angle: 60 },
  { Icon: FiHeart, title: "Nezaket ve hürmet esastır", sub: "Herkes gayretini paylaşmak için orada", angle: 120 },
  { Icon: FiLock, title: "Kişisel bilgilerinizi paylaşmayın", sub: "Şifrenizi hiçbir grupta yazmayın", angle: 180 },
];

/** Ortadaki büyük yuvarlak Katıl düğmesi; arkasında yayılan yeşil dalgalar. */
function JoinOrb({ inView }) {
  return (
    <Reveal animation="pop" inView={inView} delay={0.15} className="relative flex items-center justify-center">
      {[0, 1.2, 2.4].map((delay) => (
        <span
          key={delay}
          aria-hidden
          className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366]/35 animate-ripple motion-reduce:hidden"
          style={{ animationDelay: `${delay}s` }}
        />
      ))}
      <span aria-hidden className="pointer-events-none absolute -inset-6 rounded-full bg-[#25D366]/15 blur-2xl" />
      <a
        href={WHATSAPP_COMMUNITY_URL}
        {...external}
        aria-label="WhatsApp'ta Terakki Topluluğuna katıl"
        className="relative flex h-[140px] w-[140px] md:h-[180px] md:w-[180px] flex-col items-center justify-center gap-1.5 rounded-full bg-gradient-to-br from-[#25D366] to-[#1FA855] text-white shadow-[0_18px_45px_-12px_rgba(31,168,85,0.7)] ring-4 ring-white/70 transition-all duration-300 hover:scale-105 hover:shadow-[0_22px_60px_-8px_rgba(37,211,102,0.85)] focus:outline-none focus-visible:ring-[#25D366]/50 focus-visible:ring-offset-4 active:scale-100 motion-reduce:transition-none"
      >
        <FaWhatsapp aria-hidden className="text-5xl md:text-[3.75rem]" />
        <span className="text-xl md:text-3xl font-SemiBold tracking-wide">Katıl</span>
      </a>
    </Reveal>
  );
}

/** Halka çizgisi: yalnız çizgi döner, yazılar sabit kalır. */
function Ring({ radius, className, spin }) {
  return (
    <div
      aria-hidden
      className={`absolute rounded-full border border-dashed ${className} ${
        spin ? `animate-spin ${spin} motion-reduce:animate-none` : ""
      }`}
      style={{
        left: STAGE.cx - radius,
        top: STAGE.cy - radius,
        width: radius * 2,
        height: radius * 2,
      }}
    />
  );
}

/** Dış halkadaki küçük düğüm: ikon halkanın üstünde, yazı dışa doğru. */
function OuterNode({ item, kind, inView, delay, floatDelay }) {
  const { x, y } = at(item.angle, OUTER);
  const cos = Math.cos((item.angle * Math.PI) / 180);
  const side = cos > 0.3 ? "right" : cos < -0.3 ? "left" : "right";
  const textPos =
    side === "left"
      ? "right-full mr-3 top-1/2 -translate-y-1/2 text-right items-end"
      : "left-full ml-3 top-1/2 -translate-y-1/2 text-left items-start";
  const rule = kind === "rule";
  return (
    <div className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: x, top: y }}>
      <Reveal animation="pop" inView={inView} delay={delay}>
        <div className="relative animate-float-slow motion-reduce:animate-none" style={{ animationDelay: `${floatDelay}s` }}>
          <span
            className={`flex h-11 w-11 items-center justify-center rounded-full ring-4 ring-white/80 shadow-md ${
              rule
                ? "bg-[#FFF4E3] text-[#C9801E] shadow-[#E8A23A]/20"
                : "bg-terakkiBrandMist text-terakkiPrimaryDark shadow-terakkiPrimaryDark/15"
            }`}
          >
            <item.Icon size={18} aria-hidden />
          </span>
          <div className={`absolute flex w-[180px] flex-col ${textPos}`}>
            {rule ? (
              <span className="mb-1 rounded-full bg-[#FFF4E3] px-2 py-0.5 text-[10px] uppercase tracking-[0.16em] text-[#B8741A]">
                Adab
              </span>
            ) : null}
            <p className="text-base font-SemiBold leading-snug text-terakkiInk">{item.title}</p>
            <p className="mt-0.5 text-sm leading-snug text-terakkiInk/55">{item.sub}</p>
          </div>
        </div>
      </Reveal>
    </div>
  );
}

/** Masaüstü: iç içe iki halka. lg genişlikte sahne biraz küçülür. */
function Orbit({ inView }) {
  return (
    <div className="hidden lg:block">
      <div className="flex justify-center">
        <div
          className="relative shrink-0 origin-top lg:scale-[0.86] lg:-mb-[120px] xl:scale-100 xl:mb-0"
          style={{ width: STAGE.w, height: STAGE.h }}
        >
          <svg viewBox={`0 0 ${STAGE.w} ${STAGE.h}`} className="absolute inset-0 h-full w-full" aria-hidden>
            {GROUPS.map((g, i) => {
              const p = at(g.angle, INNER);
              return (
                <line
                  key={g.title}
                  x1={STAGE.cx}
                  y1={STAGE.cy}
                  x2={p.x}
                  y2={p.y}
                  stroke="#48A6A7"
                  strokeOpacity={inView ? 0.35 : 0}
                  strokeWidth={1.2}
                  strokeDasharray="3 6"
                  style={{ transition: `stroke-opacity .8s ease ${0.5 + i * 0.2}s` }}
                />
              );
            })}
          </svg>
          <Ring radius={OUTER} className="border-terakkiPrimary/20" spin="[animation-duration:240s]" />
          <Ring radius={INNER} className="border-terakkiPrimary/40" spin="[animation-duration:120s] [animation-direction:reverse]" />
          <div
            aria-hidden
            className="absolute rounded-full bg-white/45"
            style={{ left: STAGE.cx - 140, top: STAGE.cy - 140, width: 280, height: 280 }}
          />

          <div className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: STAGE.cx, top: STAGE.cy }}>
            <JoinOrb inView={inView} />
          </div>

          {GROUPS.map((g, i) => {
            const { x, y } = at(g.angle, INNER);
            return (
              <div key={g.title} className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: x, top: y }}>
                <Reveal animation="pop" inView={inView} delay={0.55 + i * 0.2}>
                  <div className="relative animate-hero-float motion-reduce:animate-none" style={{ animationDelay: `${i * 1.3}s` }}>
                    <img
                      src={g.icon}
                      alt=""
                      aria-hidden
                      className="h-[72px] w-[72px] rounded-full ring-4 ring-white shadow-lg shadow-terakkiPrimaryDark/20"
                    />
                    <div className="absolute left-1/2 top-full mt-3 w-[196px] -translate-x-1/2 text-center">
                      <h3 className="text-lg font-SemiBold text-terakkiInk">{g.title}</h3>
                      <p className="mt-1 text-sm leading-snug text-terakkiInk/65">{g.purpose}</p>
                    </div>
                  </div>
                </Reveal>
              </div>
            );
          })}

          {BENEFITS.map((item, i) => (
            <OuterNode key={item.title} item={item} kind="benefit" inView={inView} delay={1.2 + i * 0.15} floatDelay={i * 1.7} />
          ))}
          {RULES.map((item, i) => (
            <OuterNode key={item.title} item={item} kind="rule" inView={inView} delay={1.65 + i * 0.15} floatDelay={i * 1.7 + 0.8} />
          ))}
        </div>
      </div>
    </div>
  );
}

function StackTitle({ children }) {
  return <p className="pt-8 pb-3 text-xs uppercase tracking-[0.22em] text-terakkiPrimaryDark/70">{children}</p>;
}

/** Telefon: düğme, gruplar, faydalar ve adap çizgili satırlar halinde. */
function Stack({ inView }) {
  return (
    <div className="lg:hidden flex flex-col items-center">
      <div className="py-12">
        <JoinOrb inView={inView} />
      </div>
      <div className="w-full max-w-md">
        <ul className="border-t border-terakkiBrandMist">
          {GROUPS.map((g, i) => (
            <Reveal
              key={g.title}
              as="li"
              inView={inView}
              delay={0.45 + i * 0.12}
              className="flex items-start gap-4 border-b border-terakkiBrandMist py-4"
            >
              <img src={g.icon} alt="" aria-hidden className="h-12 w-12 shrink-0 rounded-full shadow-md shadow-terakkiPrimaryDark/15" />
              <div>
                <h3 className="text-md font-SemiBold text-terakkiInk">{g.title}</h3>
                <p className="mt-0.5 text-sm leading-relaxed text-terakkiInk/65">{g.purpose}</p>
              </div>
            </Reveal>
          ))}
        </ul>

        {[
          { title: "Topluluk ne işe yarıyor", items: BENEFITS, rule: false },
          { title: "Topluluk adabı", items: RULES, rule: true },
        ].map((block) => (
          <Reveal key={block.title} inView={inView} delay={0.8}>
            <StackTitle>{block.title}</StackTitle>
            <ul className="border-t border-terakkiBrandMist">
              {block.items.map(({ Icon, title, sub }) => (
                <li key={title} className="flex items-center gap-3 border-b border-terakkiBrandMist py-3">
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${
                      block.rule ? "bg-[#FFF4E3] text-[#C9801E]" : "bg-terakkiBrandMist text-terakkiPrimaryDark"
                    }`}
                  >
                    <Icon size={16} aria-hidden />
                  </span>
                  <div>
                    <p className="text-base font-SemiBold leading-snug">{title}</p>
                    <p className="text-sm text-terakkiInk/55">{sub}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  );
}

/** Terakki Topluluğu: ortada Katıl düğmesi, iç halkada gruplar, dış halkada faydalar ve adap. */
export default function Community() {
  const [ref, inView] = useInView({ threshold: 0.15 });

  return (
    <main className="relative w-full overflow-hidden text-terakkiInk">
      {/* yumuşak zemin lekeleri */}
      <div aria-hidden className="pointer-events-none absolute left-1/2 top-72 -z-10 h-[40rem] w-[40rem] -translate-x-1/2 rounded-full bg-terakkiBrandMist/70 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -left-32 top-[30rem] -z-10 h-80 w-80 rounded-full bg-[#25D366]/10 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-24 top-24 -z-10 h-96 w-96 rounded-full bg-terakkiBrandSoft/30 blur-3xl" />

      <section className="max-w-3xl mx-auto px-6 pt-4 text-center space-y-4">
        <p className="animate-hero-in motion-reduce:animate-none text-xs uppercase tracking-[0.22em] text-terakkiPrimaryDark/70">
          Terakki Topluluğu
        </p>
        <h1
          className="animate-hero-in motion-reduce:animate-none text-5xl md:text-8xl font-SemiBold leading-tight tracking-tight"
          style={{ animationDelay: "0.12s" }}
        >
          Soru, öneri ve duyurular için bir aradayız
        </h1>
        <p
          className="animate-hero-in motion-reduce:animate-none text-lg text-terakkiInk/70 leading-relaxed"
          style={{ animationDelay: "0.24s" }}
        >
          WhatsApp topluluğumuza katılın, konunuza uygun gruba yazın.
        </p>
      </section>

      <section ref={ref} className="max-w-6xl mx-auto px-6 pt-4 lg:pt-2 pb-20 md:pb-24">
        <Orbit inView={inView} />
        <Stack inView={inView} />
      </section>
    </main>
  );
}
